// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { ListVatWhiteListVerificationsData, ListVatWhiteListVerificationsErrors, ListVatWhiteListVerificationsResponses, SearchVatWhiteListData, SearchVatWhiteListErrors, SearchVatWhiteListResponses, VerifyVatWhiteListAccountData, VerifyVatWhiteListAccountErrors, VerifyVatWhiteListAccountResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const searchVatWhiteList = <ThrowOnError extends boolean = false>(options: Options<SearchVatWhiteListData, ThrowOnError>) => (options.client ?? client).post<SearchVatWhiteListResponses, SearchVatWhiteListErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/contragents/vat-white-list/search',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const verifyVatWhiteListAccount = <ThrowOnError extends boolean = false>(options: Options<VerifyVatWhiteListAccountData, ThrowOnError>) => (options.client ?? client).post<VerifyVatWhiteListAccountResponses, VerifyVatWhiteListAccountErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/contragents/{id}/bank-accounts/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listVatWhiteListVerifications = <ThrowOnError extends boolean = false>(options: Options<ListVatWhiteListVerificationsData, ThrowOnError>) => (options.client ?? client).get<ListVatWhiteListVerificationsResponses, ListVatWhiteListVerificationsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/contragents/{id}/bank-account-verifications',
    ...options
});
